//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'DukeDiagnosticCriteria',
  data() {
    return {
      defaultJson:{
        "infectivityint": "2次独立血培养均发现下述典型的感染性心内膜炎致病菌之一：草绿色链球菌，或牛链球菌，或HACEK菌群，或社区获得的无原发病灶的金黄色葡萄球菌或肠球菌\n感染性心内膜炎致病菌持续血培养阳性（持续性菌血症），定义为：2次血培养结果阳性（检测间隔超过12h），或3次独立血培养均阳性或4次独立血培养中大多数结果阳性（其中第一次与最后一次采血间隔超过1h)\n至少一次阳性血培养结果中检测到贝氏柯克斯体（Coxiella burnetii ）或相反型I型IgG抗体滴度>1：800",
        "evidenceint": "可活动的心内赘生物附着于瓣膜或其支持结构、在返流的路径上、或在植入物表面，或脓肿，或新出现的人工瓣膜裂缝或新的瓣膜反流（原有的杂音加重或改变不足以达到标准)",
        "factorint": "心脏静脉因素或静脉药瘾者",
        "feverint": "体温>38°C",
        "vascularint": "大动脉栓塞\n脓毒性肺梗死\n霉菌性动脉瘤\n颅内出血\n结膜出血\n詹韦氏（Janeway）损害",
        "immuneint": "肾小球肾炎\nOsler结节\nRoth斑\n类风湿因子",
        "microbiologicalint": "血培养皿阳性但不足以满足主要标准，或感染性心内膜炎致病原微生物活 动性感染的血清证据"
      },
      form:{
        infectivity:'0',
        evidence:'0',
        factor:'0',
        fever:'0',
        vascular:'0',
        immune:'0',
        microbiological:'0',
      },
      primary: 0,
      secondary: 0,
      descTxt: '',
      disabled:false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      // 诊断标准：如果符合两项主要标准、一项主要标准和三项次要标准、或五项次要标准，即可明确诊断为感染性心内膜炎，如果仅符合一项主要标准和一项次要标准或仅符合三项次要标准则提示“可能”为感染性心内膜炎。
      let primaryResult = form.infectivity + form.evidence
      self.primary = primaryResult
      let secondaryResult = form.factor + form.fever + form.vascular + form.immune + form.microbiological
      self.secondary = secondaryResult
      if ((primaryResult == 1 && secondaryResult == 0) || (primaryResult == 0 && secondaryResult <3)) {
        self.descTxt = '不符合诊断'
      } else if ((primaryResult == 2 && secondaryResult >= 0) || (primaryResult >= 1 && secondaryResult >= 3) || (primaryResult == 0 && secondaryResult == 5)) {
        self.descTxt = '符合诊断'
      } else {
        self.descTxt = '"可能"感染性心内膜炎'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/DukeDiagnosticCriteria.vue